import { Badge } from '@captaincause/ui/Badge'
import type { BadgeProps, BadgeVariant } from '@captaincause/ui/Badge'
import type { StrapiPostTag } from 'types/strapi/post'

const COLORS: Record<StrapiPostTag, BadgeVariant> = {
  marketing: 'purple',
  loyalty: 'red',
  'solidarity-gift': 'blue',
  news: 'green',
  companies: 'beige',
  'no-bullshit': 'purple',
  resources: 'red',
  impact: 'orange',
  rh: 'green',
  rse: 'purple',
  communication: 'red',
  commercial: 'blue',
  event: 'beige',
}

export const LABELS: Record<StrapiPostTag, string> = {
  marketing: 'Marketing',
  loyalty: 'Fidélisation',
  'solidarity-gift': 'Cadeau solidaire',
  news: 'Actualité',
  resources: 'Ressources',
  companies: 'Engagement des entreprises',
  impact: "Nos belles histoires d'impact",
  'no-bullshit': 'No Bullshit',
  rh: 'RH',
  event: 'Événementiel',
  rse: 'RSE',
  communication: 'Communication',
  commercial: 'Commercial',
}

interface TagProps
  extends Omit<BadgeProps<StrapiPostTag>, 'variant' | 'children'> {
  variant: StrapiPostTag
}

export function Tag({
  variant,
  onClick,
  value,
  selected,
  className,
}: TagProps) {
  return (
    <Badge<typeof variant>
      variant={COLORS[variant] ?? COLORS.companies}
      onClick={onClick}
      value={value}
      selected={selected}
      className={className}
    >
      {LABELS[variant] ?? LABELS.companies}
    </Badge>
  )
}
